import {createContext} from 'react'

const EstatusVentaMostradorContext = createContext()

export default EstatusVentaMostradorContext